import { useContext } from "react";
import CommonContext from "../contexts/Common";

const useCommons = () => useContext(CommonContext);

export default useCommons;
